module.exports = "//static.hsappstatic.net/cms-free-branding-lib/static-1.267/assets/sprocket_white.svg"